/**
 * Option builders for the settings selection modals.
 *
 * Label resolution mirrors what the page already did with react-select:
 * prefer the current language's `*_name`, then fall back through the other
 * shapes the API has used, then a last-resort id label so an option is never
 * blank and unclickable.
 */

export function currentLang(i18nLanguage) {
  return i18nLanguage?.startsWith('es') ? 'es' : 'en'
}

function label(item, lang, fallbackPrefix) {
  return (
    item[`${lang}_name`] ??
    item.name ??
    item.en_name ??
    item.es_name ??
    `${fallbackPrefix} ${item.id}`
  )
}

export function buildSkillOptions(skills, lang) {
  return (skills ?? []).map(skill => ({
    id: skill.id,
    label: label(skill, lang, 'Skill'),
  }))
}

export function buildContributionOptions(contributions, lang) {
  return (contributions ?? []).map(contribution => ({
    id: contribution.id,
    label: label(contribution, lang, 'Contribution'),
  }))
}

export function buildCauseOptions(categories, lang) {
  return (categories ?? []).map(category => ({
    id: category.id,
    label: label(category, lang, 'Cause'),
    icon: category.icon,
  }))
}
